import { ErrorResponse, ValidationErrorResponse } from '@trustblock/types/error.types';

export function isErrorResponse(obj: unknown): obj is ErrorResponse {
  return typeof obj === 'object' && obj !== null && 'message' in obj && 'code' in obj;
}

export function isValidationErrorResponse(obj: unknown): obj is ValidationErrorResponse {
  return isErrorResponse(obj) && 'validationErrors' in obj && obj.code === 'ValidationError';
}
